/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLotteryJoin.vue?vue&type=template&id=1a254d05&scoped=true"
import script from "./popLotteryJoin.vue?vue&type=script&lang=js"
export * from "./popLotteryJoin.vue?vue&type=script&lang=js"
import style0 from "./popLotteryJoin.vue?vue&type=style&index=0&id=1a254d05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a254d05",
  null
  
)

export default component.exports